import * as React from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import * as routes from "src/constants/routes";
import { DashboardForm } from "src/containers/Dashboards/DashboardForm";
import DashboardsBase, {
  IDashboardsBaseProps,
  IDashboardsBaseState,
} from "../Dashboard/DashboardsBase";

export interface IDashboardsNavProps extends IDashboardsBaseProps {
  history: any;
  authUser: any;
  orgId: string;
}

export interface IDashboardsNavState extends IDashboardsBaseState {
  x: any;
}
export default class DashboardsNav extends DashboardsBase<
  IDashboardsNavProps,
  IDashboardsNavState
> {
  constructor(props: IDashboardsBaseProps) {
    super(props);
    this.state = { ...DashboardsBase.INITIAL_STATE, x: "" };
  }

  public render() {
    const { dashboards } = this.state;
    const { authUser, orgId } = this.props;

    return (
      <React.Fragment>
        <Menu.Header>Dashboards</Menu.Header>
        <Menu.Menu className="list-menu">
          {/* <Dropdown.Item
                text="Create New"
                onClick={this.handleNewAnalysisClicked}
              />
            <Dropdown.Divider />
            <Input icon="search" iconPosition="left" className="search" /> */}

          {dashboards.map((option: any) => (
            <Menu.Item
              as={NavLink}
              activeClassName="active"
              to={routes.DASHBOARD(this.props.orgId, option.id)}
              key={option.id}
              name={option.name}
            />
          ))}
        </Menu.Menu>
        <Menu.Menu>
          <Menu.Item
            as={NavLink}
            activeClassName="active"
            to={routes.DASHBOARDS(orgId)}
            name="show all"
          />
          {/* Add Channel Modal */}
          <DashboardForm
            authUser={authUser}
            orgId={orgId}
            trigger={<Menu.Item name="new" />}
          />
        </Menu.Menu>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/DashboardsNav.tsx